import { useQuery } from "@tanstack/react-query";
import { http } from "../../../../../../services/HttpService";
import { QUERY_KEYS, HTTP_ENDPOINTS } from "../../../../../../consts/api";

export const useRetailSalesV2 = (params, options = {}) => {
  return useQuery(
    [QUERY_KEYS.retailSalesV2, params],
    async () => {
      const res = await http.get(HTTP_ENDPOINTS.getRetailSalesV2(), {
        params,
      });

      const composeResponse = {
        clinics: Object.values(res.data.data.filters.clinics || {}),
        clinicRetailSales: res.data.data.report.clinic_report,
        providerRetailSales: res.data.data.report.provider_report,
      };
      return composeResponse;
    },
    options,
  );
};
